export const useDocumentRevisionEditHistoryStore = (documentId: string) => {
  return useDocumentRevisionEditHistory(documentId)();
};
